import styled from 'styled-components';

export const PromptApprovalModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;
